import { Text, View } from '@react-pdf/renderer';
import { cellPdf, stylesPdf } from '../../../pdfs';

const fieldEmpty = (c, t) => {
  const list = [];
  const percent = (c / t) * 100;
  for (let index = 0; index < c; index++) {
    list.push(
      cellPdf({
        width: `${percent}%`,
        stylesText: stylesPdf.text,
        stylesCell: {
          borderRightWidth: index + 1 === c ? 1 : 0,
        },
      }),
    );
  }
  return list;
};

const fieldHeaderEmpty = (c, t) => {
  const list = [];
  const percent = (c / t) * 100;
  for (let index = 0; index < c; index++) {
    list.push(
      cellPdf({
        value: 'Actividad',
        width: `${percent}%`,
        stylesText: stylesPdf.text,
        bold: true,
        color: '#D6D6D6',
        stylesCell: {
          borderRightWidth: index + 1 === c ? 1 : 0,
        },
      }),
    );
  }
  return list;
};

const row = (el, i) => {
  const name = `${el.usuario.perfil.pnombre} ${
    el.usuario.perfil.snombre ?? ''
  } ${el.usuario.perfil.papellido} ${el.usuario.perfil.sapellido ?? ''}`;

  return (
    <View style={stylesPdf.row}>
      {cellPdf({
        value: i,
        width: '5%',
      })}
      {cellPdf({
        value: `${el.usuario.perfil.tipoDni}-${el.usuario.perfil.dni}`,
        width: '15%',
      })}
      {cellPdf({
        value: name,
        width: '40%',
        fontSize: name.length > 50 ? 7 : name.length > 35 ? 8 : 9,
      })}
      {fieldEmpty(4, 40)}
    </View>
  );
};

const header = (
  <View style={stylesPdf.row}>
    {cellPdf({
      value: 'Nro',
      width: '5%',
      bold: true,
      color: '#D6D6D6',
    })}
    {cellPdf({
      value: 'Identificación',
      width: '15%',
      bold: true,
      color: '#D6D6D6',
    })}
    {cellPdf({
      value: 'Nombres y Apellidos',
      width: '40%',
      bold: true,
      color: '#D6D6D6',
    })}
    {fieldHeaderEmpty(4, 40)}
  </View>
);

const TablaFamiliaresPdf = ({ data, seccion }) => {
  return (
    <View style={stylesPdf.section}>
      <View style={{ borderBottom: 1, paddingBottom: 5 }}>
        <Text style={stylesPdf.title}>LISTA DE ESTUDIANTES DE {seccion}</Text>
      </View>
      {header}
      {data.map((el, i) => row(el, i + 1))}
    </View>
  );
};

export default TablaFamiliaresPdf;
